module.exports = __webpack_public_path__ + "img/T1A_xh_1.afa9ba2c.png";